<ng-template #content_product_details let-offcanvas>
    <div class="{{localService.selectedLanguageCode}} product-details"
        *ngIf="localService.languageContent && localService.languageContent.product_config">
        <div class="side_popup_header">
            <span>{{localService.languageContent.product_config.header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div>
            <app-tab *ngIf="tabs" [tabs]="tabs" [selectedKey]="selectedTabKey"
                (onTabSelected)="onAction(1,$event)"></app-tab>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : (sideBarBodyHeight - 50) + 'px'}"
            *ngIf="productInitializationWrapper">
            <div *ngIf="selectedTabKey == '1' || selectedTabKey == '2'">
                <div class="row">
                    <div class="col-12">
                        <app-language-container *ngIf="isShowLanguage" [MaxLength]="100" [IsShowTransliterate]="true"
                            [Title]="localService.languageContent.product_config.product_header"
                            [(languageContents)]="productInitializationWrapper.product.languageContents"
                            (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,1)"
                            [MandatoryLanguages]="mandatoryLanguages" [id]="elementIds.product_name"
                            [nextId]="elementIds.hsn_code" [IsPartiallyMandatory]="true" [IsNeedNewLine]="true"
                            [IsCustomLanguageRequired]="true"></app-language-container>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox"
                                [(ngModel)]="productInitializationWrapper.product.isAutoTransateAllowed" />
                            <span
                                class="normal_color">{{localService.languageContent.common.is_auto_translation}}</span>
                        </label>
                    </div>
                </div>
                <div class="dummy">
                    &nbsp;
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <app-label [Text]="localService.languageContent.product_config.hsn_code" />
                        <input autocomplete="off" type="text" id="{{elementIds.hsn_code}}"
                            style="width: calc(100% - 35px);"
                            [ngClass]="productInitializationWrapper.product.content.v11 ? 'en' : ''"
                            [(ngModel)]="productInitializationWrapper.product.content.v11"
                            placeholder="{{localService.languageContent.product_config.hsn_code}}"
                            title="{{localService.languageContent.product_config.hsn_code}}"
                            (keydown.enter)="localService.onFocusNextInput(elementIds.sac_code, 1)" />
                        <button class="button_icon button_icon_color" (click)="onAction(3)">
                            manage_search
                        </button>
                    </div>
                    <div class="col-md-6">
                        <app-label [Text]="localService.languageContent.product_config.sac_code" />
                        <input autocomplete="off" type="text" id="{{elementIds.sac_code}}"
                            style="width: calc(100% - 35px);"
                            [ngClass]="productInitializationWrapper.product.content.v13 ? 'en' : ''"
                            [(ngModel)]="productInitializationWrapper.product.content.v13"
                            placeholder="{{localService.languageContent.product_config.sac_code}}"
                            title="{{localService.languageContent.product_config.sac_code}}"
                            (keydown.enter)="localService.onFocusNextInput(elementIds.bar_code, 1)" />
                        <button class="button_icon button_icon_color" (click)="onAction(4)">
                            manage_search
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <app-label [Text]="localService.languageContent.product_config.bar_code" />
                        <input autocomplete="off" type="text" id="{{elementIds.bar_code}}"
                            [ngClass]="productInitializationWrapper.product.content.v6 != null && productInitializationWrapper.product.content.v6 != '' ? 'en' : ''"
                            [(ngModel)]="productInitializationWrapper.product.content.v6"
                            placeholder="{{localService.languageContent.product_config.bar_code}}"
                            title="{{localService.languageContent.product_config.bar_code}}"
                            (keydown.enter)="localService.onFocusNextInput(elementIds.measurement_type, 2)" />
                    </div>
                    <div class="col-md-6">
                        <label style="margin-left:10px;font-weight:normal;">
                            <input type="checkbox" [(ngModel)]="isSerialNumberAllowed">
                            <span
                                class="normal_color">{{localService.languageContent.product_config.is_ser_allow}}</span>
                        </label>
                        <label style="font-weight: normal; margin-left: 10px;">
                            <input type="checkbox" [(ngModel)]="isTaxFree" />
                            <span
                                class="normal_color">{{localService.languageContent.product_config.is_tax_free}}</span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <app-label [Text]="localService.languageContent.product_config.measurement_type"
                            [IsMandatory]="true">
                        </app-label>
                        <ngx-select id="{{elementIds.measurement_type}}"
                            placeholder="{{localService.languageContent.product_config.select}}"
                            title="{{localService.languageContent.product_config.select}}"
                            [items]="productInitializationWrapper.measurementTypes"
                            [(ngModel)]="productInitializationWrapper.product.content.v4" [optionValueField]="'key'"
                            [optionTextField]="'value'"
                            (select)="localService.onFocusNextInput(elementIds.txt_first_price, 1)"
                            [noAutoComplete]="false">
                        </ngx-select>
                    </div>
                    <div class="col-6" *ngIf="productInitializationWrapper.categories">
                        <div>
                            <app-label [Text]="localService.languageContent.product_config.category_for_quick_pick" />
                        </div>
                        <div *ngIf="productInitializationWrapper.categories.length == 0">
                            <span>
                                {{localService.languageContent.status.data_required}}
                            </span>
                        </div>
                        <ngx-select *ngIf="productInitializationWrapper.categories.length > 0"
                            id="{{elementIds.quick_pick}}" [items]="productInitializationWrapper.categories"
                            [optionValueField]="'key'" [optionTextField]="'v1'" [multiple]="true"
                            placeholder="{{localService.languageContent.product_config.category_for_quick_pick}}"
                            title="{{localService.languageContent.product_config.category_for_quick_pick}}"
                            [(ngModel)]="productInitializationWrapper.product.categories" [noAutoComplete]="true">
                        </ngx-select>
                    </div>
                </div>
                <div class="dummy">
                    &nbsp;
                </div>
                <div *ngIf="isInventoryEnabled">
                    <div class="row">
                        <div class="col-6">
                            <div>
                                <app-label [Text]="localService.languageContent.product_config.stock" />
                                <span class="en">&nbsp;=&nbsp;{{(productInitializationWrapper.product.content ==
                                    null ?
                                    '0' :
                                    productInitializationWrapper.product.content.v2) | number: '1.2-2'}}</span>
                                <span class="en">&nbsp;+&nbsp;</span>
                            </div>
                            <!-- <div>
                                <input autocomplete="off" id="{{elementIds.add_stock}}"
                                    style="width:calc(100% - 30px);text-align:right;" type="number" class="number"
                                    (keypress)="localService.isNumberOnly($event,numericConfig)"
                                    [ngClass]="productInitializationWrapper.product.content.v5 != null && productInitializationWrapper.product.content.v5 != '' ? 'en' : ''"
                                    [(ngModel)]="productInitializationWrapper.product.content.v5"
                                    placeholder="{{localService.languageContent.product_config.add_stock}}"
                                    title="{{localService.languageContent.product_config.add_stock}}"
                                    (keydown.enter)="localService.onFocusNextInput(elementIds.qty_alert, 1)" />
                            </div> -->
                        </div>
                        <div class="col-6">
                            <app-label [Text]="localService.languageContent.product_config.qty_alert" />
                            <input autocomplete="off" id="{{elementIds.qty_alert}}"
                                style="width:calc(100% - 30px);text-align:right;" type="number" class="number"
                                (keypress)="localService.isNumberOnly($event,numericConfig)"
                                [ngClass]="productInitializationWrapper.product.content.v12 ? 'en' : ''"
                                [(ngModel)]="productInitializationWrapper.product.content.v12"
                                placeholder="{{localService.languageContent.product_config.qty_alert}}"
                                title="{{localService.languageContent.product_config.qty_alert}}"
                                (keydown.enter)="localService.onFocusNextInput(elementIds.txt_first_price, 1)" />
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!localService.isHideDummy">
                    <div class="col-12">
                        <label style="margin-left:10px;font-weight:normal;">
                            <input type="checkbox" [(ngModel)]="isPrintTax">
                            <span
                                style="color:darkslategrey">&nbsp;{{localService.languageContent.product_config.is_print_tax}}</span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <app-label [Text]="localService.languageContent.product_config.applicable_template"
                            [IsMandatory]="false">
                        </app-label>
                        <ngx-select id="{{elementIds.print_templates}}"
                            [disabled]="productInitializationWrapper.printerTemplates.length == 0"
                            placeholder="{{localService.languageContent.product_config.applicable_all}}"
                            title="{{localService.languageContent.product_config.applicable_all}}"
                            [items]="productInitializationWrapper.printerTemplates" [multiple]="true"
                            [(ngModel)]="productInitializationWrapper.product.printTemplateIds"
                            [optionValueField]="'key'" [optionTextField]="'value'" [allowClear]="true">
                        </ngx-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <app-label [Text]="localService.languageContent.product_config.product_label"
                            [IsMandatory]="false">
                        </app-label>
                        <ngx-select id="{{elementIds.product_label}}" [disabled]="productLabels.length == 0"
                            placeholder="{{localService.languageContent.product_config.product_label}}"
                            title="{{localService.languageContent.product_config.product_label}}"
                            [items]="productLabels" [multiple]="false" [noAutoComplete]="true"
                            [(ngModel)]="productInitializationWrapper.product.content.v16" [optionValueField]="'key'"
                            [optionTextField]="'value'" [allowClear]="false">
                        </ngx-select>
                    </div>
                    <div class="col-6">
                        <app-label [Text]="localService.languageContent.product_config.par_pin" [IsMandatory]="false" />
                        <input autocomplete="off" id="{{elementIds.par_pin}}"
                            style="width:calc(100% - 30px);text-align:left;" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfig1)"
                            [ngClass]="productInitializationWrapper.product.content.v17 ? 'en' : ''"
                            [(ngModel)]="productInitializationWrapper.product.content.v17"
                            placeholder="{{localService.languageContent.product_config.par_pin}}"
                            title="{{localService.languageContent.product_config.par_pin}}" />
                    </div>
                </div>
                <div class="row" *ngIf="productInitializationWrapper.product.content.v17 ? true : false">
                    <div class="col-12">
                        <label style="margin-left:30px;font-weight:normal;">
                            <input type="checkbox" [(ngModel)]="isGroupParentProductInReceipt">
                            <span
                                style="color:darkslategrey">&nbsp;{{localService.languageContent.product_config.is_group_par}}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="selectedTabKey == '1' || selectedTabKey == '3'">
                <div class="col-12">
                    <div class="dummy">
                        &nbsp;
                    </div>
                    <app-pricing-container *ngIf="productInitializationWrapper.product.price != null"
                        [(items)]="productInitializationWrapper.product.price" [isNotConsiderTax]="isNotConsiderTax"
                        [businessTaxes]="businessTaxes" [businessTaxCategories]="businessTaxCategories"
                        [(selectedBusinessTaxCategoryId)]="productInitializationWrapper.product.content.v14"
                        [navigateToNextId]="elementIds.save_product">
                    </app-pricing-container>
                </div>
            </div>
            <div class="row" *ngIf="(selectedTabKey == '1' || selectedTabKey == '3') && isExcludePrice">
                <div class="col-12">
                    <div class="dummy">
                        &nbsp;
                    </div>
                    <app-pricing-container *ngIf="productInitializationWrapper.product.priceExclude != null"
                        [(items)]="productInitializationWrapper.product.priceExclude" [isNotConsiderTax]="true"
                        [businessTaxes]="businessTaxes" [businessTaxCategories]="businessTaxCategories"
                        [(selectedBusinessTaxCategoryId)]="productInitializationWrapper.product.content.v14"
                        [isExcluded]="true">
                    </app-pricing-container>
                </div>
            </div>
            <div
                *ngIf="(selectedTabKey == '1' || selectedTabKey == '5') && productInitializationWrapper.product.customFields && productInitializationWrapper.product.customFields.length > 0">
                <div class="row">
                    <div class="col-12">
                        <div class="dummy">
                            &nbsp;
                        </div>
                        <app-label [Text]="localService.languageContent.product_config.custom_fields"
                            [IsMandatory]="false" />
                    </div>
                </div>
                <div class="row"
                    *ngFor="let customField of productInitializationWrapper.product.customFields; index as idx">
                    <div class="col-md-4" style="color:#6c757d ">
                        <span class="en">{{customField.v3}}&nbsp;-&nbsp;</span>
                        <span>{{customField.v2}}</span>
                        <span class="en">&nbsp;:&nbsp;</span>
                    </div>
                    <div class="col-md-8">
                        <input autocomplete="off" type="text" [(ngModel)]="customField.v4"
                            title="{{localService.languageContent.product_config.value}}"
                            id="{{elementIds.txt_custom_field + '_' + (idx+1)}}"
                            placeholder="{{localService.languageContent.product_config.value}}" />
                    </div>
                </div>
            </div>
            <div *ngIf="selectedTabKey == '1' || selectedTabKey == '4'">
                <div class="row">
                    <div class="col-12">
                        <div class="dummy">
                            &nbsp;
                        </div>
                        <app-language-container *ngIf="isShowLanguage" [MaxLength]="300"
                            [Title]="localService.languageContent.product_config.category_header" [IsLargeText]="true"
                            [(languageContents)]="productInitializationWrapper.product.languageCategory"
                            (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,2)"
                            [MandatoryLanguages]="mandatoryLanguages" [id]="elementIds.product_category"
                            [nextId]="elementIds.hsn_code"></app-language-container>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="dummy">
                            &nbsp;
                        </div>
                        <app-language-container *ngIf="isShowLanguage" [MaxLength]="300"
                            [Title]="localService.languageContent.product_config.about_header" [IsLargeText]="true"
                            [(languageContents)]="productInitializationWrapper.product.languageAbout"
                            (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,3)"
                            [MandatoryLanguages]="mandatoryLanguages" [id]="elementIds.product_about"
                            [nextId]="elementIds.hsn_code"></app-language-container>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="dummy">
                            &nbsp;
                        </div>
                        <app-language-container *ngIf="isShowLanguage" [MaxLength]="300"
                            [Title]="localService.languageContent.product_config.notes_header" [IsLargeText]="true"
                            [(languageContents)]="productInitializationWrapper.product.languageNotes"
                            (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,4)"
                            [MandatoryLanguages]="mandatoryLanguages" [id]="elementIds.product_notes"
                            [nextId]="elementIds.hsn_code"></app-language-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-8" style="text-align: left;">
                    <span *ngIf="message != ''"
                        [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
                </div>
                <div class="col-4" style="text-align: right;">
                    <button type="button" class="btn btn-primary"
                        (click)="onAction(2)">{{localService.languageContent.common.save}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<div>
    <app-lookup [(isOpen)]="isOpenLookup" [lookupType]="selectedLookupType" [(searchKey)]="searchKeyLookup"
        [(selectedValue)]="selectedLookupValue" (onClose)="isOpenLookup = false" (onSelect)="onSelectLookup($event)" />
</div>